<template>
  <div class="wrapper">
    <div class="tag">
      <div>尾水参数</div>
      <span />
    </div>
    <div class="inform">
      <div class="group-name">
        <div class="triangle">
          <div style="border-left-color: #3387FE;"></div>
          <div style="border-left-color: #3387FE55;"></div>
          <div style="border-left-color: #3387FE11;"></div>
        </div>
        <div class="name">{{data.name}} <span v-if="(data.powerStatus === 0)">（离线）</span></div>
      </div>
      <div class="bottom-line"></div>
    </div>
    <div class="inform-info" v-if="(data.alarmMessageList.length > 0)">
      <img src="../images/icon_ann.png" alt="">
      <span>{{data.alarmMessageList.join(' / ')}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EquipmentGroupHeader',
  data () {
    return {}
  },
  props: ['data'],
  computed: {},
  methods: {
  },
  mounted () {
  },
  deleted () {
  }
}
</script>
<style scoped lang="stylus">
.wrapper{
  width: 100%;
  height: 60px;
  display: flex;
  position: relative;
  .tag{
    width: 130px;
    position: relative;
    div{
      width: 120px;
      height: 48px;
      line-height: 48px;
      font-size: 20px;
      font-weight: 400;
      color: #001133;
      text-align: center;
      background-color: #F2F3F8;
      border-radius: 4px;
      border: 2px solid #3387FE;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    span {
      display: inline-block;
      width: 120px;
      height: 48px;
      background-color: #F2F3F8;
      border-radius: 4px;
      border: 2px solid #3387FE;
      position: absolute;
      top: 8px;
      left: 8px;
      z-index: -1;
    }
  }
  .inform{
    flex: 1;
    padding: 0 30px;
    display: flex;
    align-items: center;
    position: relative;
    .group-name{
      display: flex;
      align-items: center;
      .triangle{
        display: flex;
        div{
          width: 0;
          height: 0;
          border: 10px solid transparent;
        }
      }
      .name{
        font-size: 20px;
        font-weight: 400;
        color: #001133;
      }
    }
    .bottom-line{
      width: 100%;
      height: 2px;
      background-image: linear-gradient(to right, #3387FE 80%, transparent);
      position: absolute;
      left: 0;
      bottom: 0;
      margin-left: 30px;
      box-sizing: border-box;
    }
  }
  .inform-info{
    height: 40px;
    background: #FFB3B6;
    border-radius: 4px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    padding: 8px 24px;
    box-sizing: border-box;
    color: #4D4748;
    img{
      margin-right: 5px;
    }
  }
}
</style>
